import { MarketType } from "../types/types";

export const marketLanguageMap: Record<MarketType, "en" | "jp"> = {
  JP: "jp",
  KR: "en",
  HK: "en",
  TW: "en",
};